import { HelmetDexteel } from "@dexteel/mesf-core";
import { ForecastDataEntryManager } from "./components/ForecastDataEntryManager";

export const ForecastDataEntryPage = () => {
	return (
		<>
			<HelmetDexteel title="Forecast Data Entry" />
			<ForecastDataEntryManager />
		</>
	);
};
